import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  Chip,
  Button,
  Stack,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import EastOutlinedIcon from "@mui/icons-material/EastOutlined";
import { formatearFecha } from "../../utils/FormatoFecha";
import { motion } from "framer-motion";

const generarSlug = (titulo) => {

  return titulo
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-");
};

const aparecer = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * .12,
      duration: .7,
    },
  }),
};

export const NoticiaCard = ({ item, index }) => {
  const navigate = useNavigate();
  const backendURL = process.env.REACT_APP_BACKEND_URL;
  const handleLeerNoticia = () => {

    const tituloSlug =
      generarSlug(item.titulo);

    navigate(`/noticias/${tituloSlug}`);

  };
  return (

    <motion.div
      variants={aparecer}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      custom={index}
    >

      <Card

        elevation={0}

        sx={{

          borderRadius: "24px",

          overflow: "hidden",

          background: "#fff",

          height: "100%",

          transition: ".35s",

          border: "1px solid #eef2f7",

          "&:hover": {

            transform: "translateY(-8px)",

            boxShadow:
              "0px 22px 45px rgba(18,33,63,.12)",

          },

          "&:hover img": {

            transform: "scale(1.08)",

          },

        }}

      >

        {/* Imagen */}

        <Box

          sx={{

            overflow: "hidden",

            position: "relative",

          }}

        >

          <CardMedia

            component="img"

             src={`${backendURL}/${item.img1}`}

            sx={{

              height: 230,

              transition: ".5s",

            }}

          />

          {/* Categoría */}

          <Chip

            label={item.tipo}

            sx={{

              position: "absolute",

              left: 18,

              top: 18,

              background:
                "linear-gradient(135deg,#C62828,#8f1515)",

              color: "#fff",

              fontWeight: 700,

              borderRadius: "30px",

            }}

          />

        </Box>

        {/* Contenido */}

        <CardContent

          sx={{

            p: 3,

            display: "flex",

            flexDirection: "column",

            height: 250,

          }}

        >

          <Stack

            direction="row"

            spacing={1}

            alignItems="center"

          >

            <CalendarMonthOutlinedIcon

              sx={{

                color: "#C62828",

                fontSize: 20,

              }}

            />

            <Typography

              sx={{

                color: "#6B7280",

                fontSize: 14,

              }}

            >

              {formatearFecha(item.fecha)}

            </Typography>

          </Stack>

          <Typography

            sx={{

              mt: 2,

              color: "#12213F",

              fontWeight: 700,

              fontSize: 24,

              fontFamily: "Archivo",

              lineHeight: 1.2,

            }}

          >

            {item.titulo}

          </Typography>

          <Typography

            sx={{

              mt: 2,

              color: "#606C80",

              lineHeight: 1.7,

              flex: 1,

              display: "-webkit-box",

              WebkitLineClamp: 3,

              WebkitBoxOrient: "vertical",

              overflow: "hidden",

            }}

          >

            {item.descripcion}

          </Typography>

          <Button
            onClick={handleLeerNoticia}
            endIcon={<EastOutlinedIcon />}

            sx={{

              mt: 3,

              alignSelf: "flex-start",

              color: "#C62828",

              fontWeight: 700,

              textTransform: "none",

              p: 0,

              "&:hover": {

                background: "transparent",

                transform: "translateX(5px)",

              },

            }}

          >

            Leer noticia

          </Button>

        </CardContent>

      </Card>

    </motion.div>

  );

};